var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoSquare = function SvgInfoSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "info-square_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M60 4v56H4V4zM8 56h48V8H8zm26-31.2V43h8.4v4H21.6v-4H30V28.8h-8.4v-4zm0-11V19h-4v-5.2z"
  })));
};
export { SvgInfoSquare as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNjAgNFY2MEg0VjRINjBaTTggNTZINTZWOEg4VjU2Wk0zNCAyNC43OTk4VjQzSDQyLjQwMDRWNDdIMjEuNTk5NlY0M0gzMFYyOC43OTk4SDIxLjU5OTZWMjQuNzk5OEgzNFpNMzQgMTMuNzk5OFYxOUgzMFYxMy43OTk4SDM0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";